import type { FC } from "react";
import React from "react";

import cn from "classnames";
import getEmojiRegex from "emoji-regex";

import { createDisplayNameForAvaPictureElement } from "../../utils/getDisplayName";
import { createTestIdForAvaPictureElement } from "../../utils/getTestId";

import type { PropsWithCustomVarsStyles } from "../../../../types/react";
import type { AvaPictureShapes, AvaPictureSizes } from "../../types";

import classes from "./AvaPictureEmoji.styl";

type AvaPictureEmojiPrivateProps = PropsWithCustomVarsStyles<{
    /** Отвечает за передаваемую строку с эмодзи */
    emoji: string;
    size: AvaPictureSizes;
    shape: AvaPictureShapes;
}>;

export type AvaPictureEmojiProps = Omit<
    AvaPictureEmojiPrivateProps,
    "size" | "shape"
>;

export const AVA_PICTURE_EMOJI_TEST_ID =
    createTestIdForAvaPictureElement("emoji");

export const AvaPictureEmoji: FC<AvaPictureEmojiProps> = (props) => {
    const { emoji, size, shape, customVarsStyles } =
        props as AvaPictureEmojiPrivateProps;

    if (!getEmojiRegex().test(emoji)) {
        throw new Error(`Последовательность '${emoji}' не является эмоджи!`);
    }

    const classNames = cn(
        classes["emoji"],
        classes[`__size-${size}`],
        classes[`__shape-${shape}`],
        customVarsStyles,
    );

    return (
        <div data-tsid={AVA_PICTURE_EMOJI_TEST_ID} className={classNames}>
            {emoji}
        </div>
    );
};

AvaPictureEmoji.displayName = createDisplayNameForAvaPictureElement("Emoji");

export default AvaPictureEmoji;
